import styled from '@emotion/styled';

import {DialogHeading} from '#/Dialog/styles';
import Stepper from '#/Stepper';

export const StyledCreateDocumentFromTemplate = styled.div`
  ${Stepper} {
    margin: var(--gutter-medium) 200px var(--gutter-medium) 200px;
    justify-content: center;
  }

  & .InternalDialogWrapper {
    min-width: 0;
    height: 650px;

    ${DialogHeading} {
      margin-bottom: 0;
    }
  }
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 82px);
  padding-bottom: var(--gutter);
`;
